import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useNavigate } from 'react-router-dom';
import { ServerPath } from '../../../Constant';
import { _axios } from '../../../utils/axios';
import Swal from 'sweetalert2';

const EditJourney = ({ journey }) => {
    const [show, setShow] = useState(false);
    const [locationName, setlocationName] = useState('');
    const [locId, setlocId] = useState('');
    const [location, setLocation] = useState('');
    const [locStatus, setLocStatus] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const extractTextFromElement = (element) => {
            if (typeof element === 'string') {
                return element;
            } else if (element?.props && element?.props?.children) {
                if (Array.isArray(element?.props?.children)) {
                    return element?.props?.children.map(extractTextFromElement).join(' ');
                } else {
                    return extractTextFromElement(element?.props?.children);
                }
            }
            return '';
        };

        const nameElement = journey?.location_name;
        const nameText = extractTextFromElement(nameElement);

        setlocationName(nameText);
        setlocId(journey?.loc_id);
        setLocation(journey?.location);
        setLocStatus(journey?.status);
    }, [journey]);

    const handleClose = () => setShow(false);
    const handleShow = (event) => {
        event.preventDefault();
        setShow(true);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Check if any required field is empty
        if (!locationName.trim() || !location.trim()) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'All fields marked with * are required',
                confirmButtonColor: '#3085d6',
            });
            return;
        }

        const updatedTagDetails = {
            location_name: locationName.trim(),
            location: location.trim(),
            status: locStatus,
            loc_id: locId,
        };

        try {
            const response = await _axios.patch(`${ServerPath}/journey/update`, updatedTagDetails);
            console.log(response.data);
            handleClose();
            window.location.reload();

            // Swal.fire({
            //     icon: 'success',
            //     title: 'Success',
            //     text: 'Location updated successfully!',
            //     confirmButtonColor: '#3085d6',
            // }).then(() => {
            //     window.location.reload();
            // });
        } catch (error) {
            console.error(error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: 'An error occurred while updating the location',
                confirmButtonColor: '#3085d6',
            });
        }
    };

    return (
        <>
            <Button onClick={handleShow} className="btn-square btn btn-primary mx-2">
                <i className='icon-pencil-alt'></i>
            </Button>

            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>Edit Start Journey Locations</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formTagDetailsName">
                                <Form.Label>Location Name <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={locationName}
                                    onChange={(e) => setlocationName(e.target.value)}
                                    placeholder="Enter location name"
                                    required
                                />
                            </Form.Group>
                        </Row>
                        <Row className="mb-3">
                            <Form.Group as={Col} controlId="formLocation">
                                <Form.Label>Address <span className="text-danger">*</span></Form.Label>
                                <Form.Control
                                    type="text"
                                    value={location}
                                    onChange={(e) => setLocation(e.target.value)}
                                    placeholder="Enter complete URL address"
                                    required
                                />
                            </Form.Group>
                        </Row>
                        <Row>
                            <Form.Group as={Col} controlId='formGridStatus'>
                                <Form.Label>Status</Form.Label>
                                <Form.Control
                                    as="select"
                                    value={locStatus}
                                    onChange={(e) => setLocStatus(Number(e.target.value))}
                                >
                                    <option value={1}>Active</option>
                                    <option value={0}>Inactive</option>
                                </Form.Control>
                            </Form.Group>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>Close</Button>
                    <Button variant="primary" onClick={handleSubmit}>Update</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default EditJourney;